import { InjectionToken, Provider } from '@angular/core'
import { environment } from '../../environments/environment'

export const completedGamePollTimeoutToken = new InjectionToken<number>(
  'CompletedGamePollTimeoutToken',
)

export const completedGamePollTimeoutProvider: Provider = {
  provide: completedGamePollTimeoutToken,
  useValue: environment.completedGamePollTimeoutInMilliseconds,
}
